module.exports = __webpack_public_path__ + "img/taxi-type.94f78378.png";